import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const styles = {
  dialogTitle: {
    textAlign: "center",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  successIcon: {
    color: "green",
    fontSize: 40,
  },
  errorIcon: {
    color: "red",
    fontSize: 40,
  },
  dialogContent: {
    textAlign: "center",
  },
};

const CommonDialog = ({ open, isSuccess, onClose, messageSuccess, messageError }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle sx={styles.dialogTitle} id="dialog-title">
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={styles.closeIcon}
        >
          <CloseIcon />
        </IconButton>
        {isSuccess ? (
          <CheckCircleIcon sx={styles.successIcon} />
        ) : (
          <CancelIcon sx={styles.errorIcon} />
        )}
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography
          id="dialog-description"
          variant="body1"
          gutterBottom
        >
          {isSuccess ? messageSuccess : messageError}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default CommonDialog;
